// extracted by mini-css-extract-plugin
export default {"tabsBox":"tabs_tabsBox__DmooQ","tabs":"tabs_tabs__Rf1ru","tab":"tabs_tab__cw+aR","active":"tabs_active__2El7m","panels":"tabs_panels__YGB3n","panel":"tabs_panel__SlNjD"};